// extracted by mini-css-extract-plugin
module.exports = {"lastLogon":"LastLogon__lastLogon___2YsUk"};